import React from "react";
import styles from "../../assets/styles/_FAQ.module.scss";
import FadeInSection from "../common/FadeInSection";
import Breadcrumb from "../common/breadcrum";
import SlideProduct from "../common/slideProduct";

const FAQPageComponent = () => {
  const data = [
    {
      A: "シャンプーはノンシリコーンですが、ヘアトリートメントは指通りやまとまりを出すため、シリコーンを適量配合しております。",
      Q: "シャンプー・ヘアトリートメントはノンシリコーンですか？",
    },
    {
      A: "ディープモイストシリーズ：髪の毛が普通〜太い、普通〜硬い、普通〜多いと感じられる方で、パサつきや毛先の広がりに悩み、しっとりとしたうるおいのある仕上がりを求めている方におすすめです。<br/>スリークモイストシリーズ：髪の毛が普通〜細い、普通〜柔らかい、普通〜少ないと感じられる方で、パサつきやからまりに悩み、うるおいがあり指通りのよいサラサラした仕上がりを求めている方におすすめです。",
      Q: "どのような髪質に適していますか？",
    },
    {
      A: "髪質にあわせた処方となり、同じシリーズのシャンプーとヘアトリートメントの組み合わせでお使いいただいた方がその製品の特長が出やすくなるため、出来るだけ同じシリーズでお使いいただくことをおすすめしております。",
      Q: "シャンプーとトリートメントは同じシリーズを使用すべきですか？",
    },
    {
      A: "ポンプの首部①を片手で押さえながら頭部②を固定して、矢印の方向（左回り）に回すと頭部が上がります。 中身が出るまで、数回カラ押ししてください。 頭部②が上がらないときは、首部①を固く締めなおして手で固定し、頭部②を再度回してください。以上の作業を数回お試しいただいても回らない場合はお手数ですが、お客様相談室までご連絡ください。",
      Q: "シャンプー・ヘアトリートメントのポンプが上がらないのですが、どのようにすればよいでしょうか？",
    },
    {
      A: "＜シャンプー・トリートメント＞<br/>1プッシュあたり約3mLですので、髪の長さにあわせて以下の使用量をご参考ください。<br/>ショート：1〜2プッシュ=3mL〜6ｍL<br/>ミディアム：2〜3プッシュ=6mL〜9mL<br/>ロング：3〜4プッシュ=9mL〜12mL<br/>＜ヘアオイル・ヘアミルク＞<br/>1プッシュあたり約1mLですので、髪の長さにあわせて以下の使用量をご参考ください。<br/>ショート：1プッシュ=1mL<br/>ミディアム：2プッシュ=2mL<br/>ロング：2〜3プッシュ=2mL〜3mL<br/>*髪の量によっても異なりますので、ご自身で調整しながらご使用ください。",
      Q: "使用量に目安はありますか？",
    },
    {
      A: "粘度が高い為、中身が出にくい時はボトルの横を数回たたいてください。",
      Q: "トリートメントがポンプから汲み上げにくいときはどうすればよいですか？",
    },
    {
      A: "ヘアトリートメントは塗布後2-3分放置していただくと、よりケア効果が高まる傾向がございます。",
      Q: "ヘアトリートメントは、塗布後に時間を置いた方が良いですか？",
    },
    {
      A: "ヘアオイルを含む洗い流さないヘアトリートメントは、ドライ前・ドライ後両方ご使用出来ます。お好みでお選びいただければと思います。",
      Q: "ヘアオイルなどの洗い流さないヘアトリートメントはドライ前に使用出来ますか？",
    },
    {
      A: "＜シャンプー・トリートメント＞<br/>使用回数や髪の量によりますが、1日1回2プッシュ（約6mL）で計算しますと、75日（約2ヶ月半）程度で使いきることになります。<br/>＜ヘアオイル・ヘアミルク＞<br/>使用回数や髪の量によりますが、1日1回2プッシュ（約2mL）で計算しますと、50日（約2ヶ月弱）程度で使いきることになります。",
      Q: "1本でどれくらいの期間、使用できますか？",
    },
    {
      A: "使用期限はございませんが、未開封の場合において製造後3年間は品質が保たれるように製造しています。基本的には、製造から3年以上経過してもすぐに品質が劣化することはございませんが、保管場所、保存状態により推奨している期間内であっても劣化や変性が生じることがまれにございます。期間内、期間外問わず、臭い、色、感触等に異常がある場合は使用はおすすめいたしません。開封後は早めにご使用ください。",
      Q: "使用期限はありますか？",
    },
    {
      A: "天然由来の原料を使用している為、ロットにより色や香りにバラつきが生じることがあります。また経時変化により黄変や香調が変化することがありますが、品質には問題ありません。",
      Q: "シャンプーの色が黄色くなっていますが、品質に問題はありませんか？",
    },
    {
      A: "基本的にはございません。しかしヘアカラーの直後はどのようなシャンプーでもヘアカラーの褪色の原因となることがありますので、最低限の回数で髪を洗われることをおすすめします。",
      Q: "パーマやヘアカラーの持続に影響はありますか？",
    },
    {
      A: "ご使用いただけます。ただし敏感な時期ですので、使用中や使用後に異常を感じられたらすぐに使用を中止してください。",
      Q: "妊娠・授乳中の方でも使用可能ですか？",
    },
    {
      A: "無理に吐き出そうとせず、口に残ったものを水ですすぎ、コップ１～2杯の牛乳や水を飲んでください。異常を感じる場合は、商品を持参の上、医師にご相談ください。",
      Q: "誤ってシャンプーやトリートメントなどをのんでしまいましたが、大丈夫ですか？",
    },
    {
      A: "弊社は、化粧品の研究・開発においては動物実験を行っておらず、外部にも動物実験を委託しておりません。<br />今後も自社・関連会社における実施・外部委託を問わず、化粧品のための動物実験は行わない方針です。",
      Q: "動物実験は行っていますか？",
    },
    {
      A: "試供品のご用意はございません。シャンプー・ヘアトリートメント1回使い切りタイプ、ヘアミルク・ヘアオイル1回使い切りタイプを店舗で販売させていただいておりますので、そちらをお買い求めください。",
      Q: "試供品はありますか？",
    },
  ];
  return (
    <div className={styles.FAQ}>
      <div className={styles.FAQTitle}>FAQ</div>
      <div className={styles.FAQList}>
        {data.map((item, index) => (
          <div className={styles.FAQItems} key={index}>
            <div className={styles.FAQItem}>
              <div className={styles.FAQItemTitle}>Q</div>
              <p>{item.Q}</p>
            </div>
            <div className={styles.FAQItem}>
              <div className={styles.FAQItemTitle}>A</div>
              <p dangerouslySetInnerHTML={{ __html: item.A }} />
            </div>
          </div>
        ))}
      </div>
      <SlideProduct />
      <Breadcrumb
        data={[
          { title: "TOP", link: "/" },
          { title: "FAQ", link: "/faq" },
        ]}
      />
    </div>
  );
};

export default FAQPageComponent;
